module.exports = __webpack_public_path__ + "img/Ulnar-sidedwristpain_1.c2865b97.gif";